import { PLAN_ORDER } from "../../../utils/helpers/subscriptions/plans";
import { buildSubscriptionRows } from "../../../utils/helpers/subscriptions/utils";
import styles from "./SubscriptionPlansTable.module.css";
import TableCell from "../tableCell/TableCell";
import { useMemo, useState } from "react";

const SubscriptionPlansTable = ({ t, plansData = [] }) => {
  const [open, setOpen] = useState(false);

  const sortedPlans = useMemo(() => {
    return [...plansData].sort(
      (a, b) => PLAN_ORDER.indexOf(a.plan) - PLAN_ORDER.indexOf(b.plan)
    );
  }, [plansData]);

  const rows = useMemo(() => 
    buildSubscriptionRows(sortedPlans, t
  ), [sortedPlans, t]);

  return (
    <div className={styles.wrapper}>
      <button className={styles.toggleBtn} onClick={() => setOpen((v) => !v)} >
        {t("compare_all_features")}
        <span className={`${styles.chevron} ${ open ? styles.up : styles.down}`}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 10l5-5 5 5" stroke="#333" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>

      <div className={`${styles.tableWrap} ${open ? styles.open : styles.closed}`}>
        <div className={`${styles.compareRow} ${styles.headerRow}`}>
          <div className={styles.headerTitle}>{t("features")}</div>

          {sortedPlans.map((p) => (
            <div key={p} className={styles.tableCell}>
              <div className={styles.planTitle}>{t( p?.plan?.toLowerCase())}</div>
            </div>
          ))}
        </div>

        {rows.map((row, i) => (
          <div
            key={row.feature}
            className={`${styles.compareRow} ${open ? styles.animatedRow : ""}`}
            style={{ animationDelay: open ? `${i * 0.06}s` : "0s" }}
          >
            <div className={styles.featureText}>{row.feature}</div>

            {row.values.map((val, j) => (
              <div key={j} className={styles.tableCell}>
                <TableCell value={val} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionPlansTable;